import React from "react";
import { useStore } from "../../../store/store";

function useAutomationSelector() {
  const addToQuote = useStore((state) => state.addToQuote);

  const automationChoice = useStore((state) => state.quote.automation);

  const handleClick = (label: string) => {
    const checked = checkMark(label);
    addToQuote({ automation: !checked ? label : "" });
  };

  const variant = (label: string) =>
    label === automationChoice ? "filled" : "outlined";

  const checkMark = (label: string) => label === automationChoice;

  return {
    checkMark,
    variant,
    handleClick,
  };
}

export default useAutomationSelector;
